import { useState } from "react";
import type { Anime } from "@/mocks/anime";

interface MockPlayerProps {
  anime: Anime;
  episode: number;
}

export default function MockPlayer({ anime, episode }: MockPlayerProps) {
  const [playing, setPlaying] = useState(false);

  return (
    <div className="w-full rounded-lg overflow-hidden bg-foreground-950">
      <div className="relative w-full aspect-video bg-foreground-950">
        <img
          src={anime.banner || anime.cover}
          alt={`${anime.title} 播放区`}
          title={`${anime.title} 在线播放演示`}
          className={`w-full h-full object-cover object-top transition-opacity duration-500 ${
            playing ? "opacity-40" : "opacity-70"
          }`}
        />
        <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/85 to-foreground-950/20"></div>

        <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-4">
          {playing ? (
            <div className="animate-fadeIn">
              <span className="w-14 h-14 rounded-full bg-primary-500/90 text-background-50 flex items-center justify-center text-2xl mx-auto mb-4">
                <i className="ri-equalizer-line animate-pulse"></i>
              </span>
              <p className="text-background-50 text-base md:text-lg font-semibold">
                正在播放 {anime.title} · 第 {episode} 集
              </p>
              <p className="text-background-200/80 text-xs md:text-sm mt-2 max-w-md mx-auto leading-relaxed">
                当前为演示播放模式，仅做界面与交互演示，本站不提供真实视频流。
                点击下方按钮可返回集数选择。
              </p>
              <button
                type="button"
                onClick={() => setPlaying(false)}
                className="mt-5 inline-flex items-center gap-2 px-5 py-2 rounded-md bg-background-50/15 text-background-50 text-sm font-medium border border-background-50/30 hover:bg-background-50/25 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-stop-circle-line text-lg"></i>
                停止演示
              </button>
            </div>
          ) : (
            <div className="animate-fadeIn">
              <button
                type="button"
                onClick={() => setPlaying(true)}
                aria-label="播放"
                className="w-16 h-16 md:w-20 md:h-20 rounded-full bg-primary-500 text-background-50 flex items-center justify-center text-3xl md:text-4xl hover:bg-primary-600 hover:scale-105 transition-all cursor-pointer"
              >
                <i className="ri-play-fill"></i>
              </button>
              <p className="text-background-50 text-sm md:text-base font-medium mt-4">
                点击播放 第 {episode} 集（演示）
              </p>
              <p className="text-background-200/70 text-xs mt-1">播放功能为前端模拟，不含真实视频数据</p>
            </div>
          )}
        </div>

        <div className="absolute top-3 left-3 flex items-center gap-2">
          <span className="px-2.5 py-1 rounded-md bg-foreground-950/70 text-background-50 text-xs backdrop-blur-sm">
            第 {episode} 集
          </span>
          <span className="px-2.5 py-1 rounded-md bg-primary-500/90 text-background-50 text-xs font-medium">
            演示播放
          </span>
        </div>
      </div>

      <div className="flex items-center justify-between px-4 py-3 bg-background-100 border-t border-background-200">
        <p className="text-xs text-foreground-600 truncate">
          正在浏览：<span className="font-medium text-foreground-900">{anime.title}</span>
        </p>
        <p className="text-xs text-foreground-500 whitespace-nowrap shrink-0 ml-3">
          <i className="ri-information-line mr-1"></i>
          本站内容均为演示
        </p>
      </div>
    </div>
  );
}